import React from 'react'
import { TextAreaInput } from '@ztechapps/webui.input'
import { Field } from '@ztechapps/webui.form'

export const TextTemplateInputValue = () => {
  return (
    <Field
      {...{
        name: 'value',
        label: 'Value',
        rows: 10,
        component: TextAreaInput,
      }}
    />
  )
}
